import {IGoodsClassified2ViewDTO, IGoodsConvolution, IGoodsDTO, IGoodsViewDTO, IGoodsWtruCodeGroupDTO } from "../../../libs/coreapi-dto/dirs/goods";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
//import {IGoodsAttributes, IGoodsAssortmentPlanning,IGoodsGnvls,IGoodsName,IGoodsOtherCodes,IGoodsPacking } from "../../../libs/coreapi-dto/dirs/goods";

export interface IGoodsByIdDTO extends IGoodsDTO {
    readonly idGlobal: string
}

class GoodsRequest extends BaseDirRequest<IGoodsViewDTO, IGoodsDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "Goods", token, eventHandler)
    }
    
    attachToGroup(idGoodsGlobal:string, idGoodsGroupGlobal: string, callback: ( e: CoreApiResponse<null>) => void) {
        super.patch(`${this._baseUrl}/${this._routePrefix}/${idGoodsGlobal}/AttachToGroup/${idGoodsGroupGlobal}`, null, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }

    moveFromGroup(idGoodsGlobal:string, fromIdGoodsGroupGlobal: string, toIdGoodsGroupGlobal: string, callback: ( e: CoreApiResponse<null>) => void) {
        super.patch(`${this._baseUrl}/${this._routePrefix}/${idGoodsGlobal}/MoveFromGroup/${fromIdGoodsGroupGlobal}/To/${toIdGoodsGroupGlobal}`, null, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e); 
        })
    }

    detachFromGroup(idGoodsGlobal:string, idGoodsGroupGlobal: string, callback: ( e: CoreApiResponse<null>) => void) {
        super.delete(`${this._baseUrl}/${this._routePrefix}/${idGoodsGlobal}/DetachFromGroup/${idGoodsGroupGlobal}`, null, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }

    attachToClassifier(idGoodsGlobal:string, idGoodsClassifierGlobal: string, callback: ( e: CoreApiResponse<null>) => void) {
        super.patch(`${this._baseUrl}/${this._routePrefix}/${idGoodsGlobal}/AttachToClassifier/${idGoodsClassifierGlobal}`, null, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }

    moveFromClassifier(idGoodsGlobal:string, fromIdGoodsClassifierGlobal: string, toIdGoodsClassifierGlobal: string, callback: ( e: CoreApiResponse<null>) => void) {
        super.patch(`${this._baseUrl}/${this._routePrefix}/${idGoodsGlobal}/MoveFromClassifier/${fromIdGoodsClassifierGlobal}/To/${toIdGoodsClassifierGlobal}`, null, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }

    detachFromClassifier(idGoodsGlobal:string, idGoodsClassifierGlobal: string, callback: ( e: CoreApiResponse<null>) => void) {
        super.delete(`${this._baseUrl}/${this._routePrefix}/${idGoodsGlobal}/DetachFromClassifier/${idGoodsClassifierGlobal}`, null, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }

    setRating(idGoodsGlobal:string, idGoodsClassifierGlobal: string, rate: number, callback: ( e: CoreApiResponse<null>) => void) {
        super.patch(`${this._baseUrl}/${this._routePrefix}/${idGoodsGlobal}/FromClassifier/${idGoodsClassifierGlobal}/SetRating/${rate}`, null, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }

    convolute(convolution: IGoodsConvolution, callback: (e: CoreApiResponse<boolean>) => void, failedCallback?: (e) => void) {
        this.post<boolean>(`${this._baseUrl}/${this._routePrefix}/Convolute`, convolution, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    failedCallback?.(e);
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        });
    }

    getGoodsByBarcode(externalBarcode: string, callback: (e) => void) {
        this.get(`${this._baseUrl}/${this._routePrefix}/GetByExternalBarcode/${externalBarcode}`,this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),  e => { 
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        })
    }
    
    getGoodsByBarcodeWithGosContract(externalBarcode: string, idGosContactGlobal: string, callback: (e) => void) {
        this.get(`${this._baseUrl}/${this._routePrefix}/GetByExternalBarcode/${externalBarcode}/${idGosContactGlobal}`,this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),  e => { 
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        })
    }

    getGoodsByCode(code: string, callback: (e) => void) {
        this.get(`${this._baseUrl}/${this._routePrefix}/GetByCode/${code}`,this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),  e => { 
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        })
    }

    getGoodsByCodeWithGosContract(code: string, idGosContactGlobal: string, callback: (e) => void) {
        this.get(`${this._baseUrl}/${this._routePrefix}/GetByCode/${code}/${idGosContactGlobal}`,this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),  e => { 
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        })
    }

    getViewByName(body: IViewBody, callback: (e: CoreApiResponse<IViewWrapper<IGoodsViewDTO>>) => void, signal?: AbortSignal | null) {        
        this.post<IViewWrapper<IGoodsViewDTO>>(`${this._baseUrl}/${this._routePrefix}/ViewByName`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        }, signal)
    }

    getViewByNameSmart(body: IViewBody, callback: (e: CoreApiResponse<IViewWrapper<IGoodsViewDTO>>) => void, signal?: AbortSignal | null) {        
        this.post<IViewWrapper<IGoodsViewDTO>>(`${this._baseUrl}/${this._routePrefix}/ViewByNameSmart`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        }, signal)
    }

    getDistinctViewByStore(body: IViewBody, callback: (e: CoreApiResponse<IViewWrapper<IGoodsViewDTO>>) => void, signal?: AbortSignal | null) {        
        this.post<IViewWrapper<IGoodsViewDTO>>(`${this._baseUrl}/${this._routePrefix}/DistinctViewByStore`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        }, signal)
    }

    getViewCustom(body: IViewBody, callback: (e: CoreApiResponse<IViewWrapper<IGoodsViewDTO>>) => void) {        
        this.post<IViewWrapper<IGoodsViewDTO>>(`${this._baseUrl}/${this._routePrefix}/ViewCustom`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        })
    }

    // Использовать только paramFilter.IdGoodsClassifierGlobal
    getViewClassified(body: IViewBody, callback: (e: CoreApiResponse<IViewWrapper<IGoodsClassified2ViewDTO>>) => void, signal?: AbortSignal | null) {        
        this.post<IViewWrapper<IGoodsClassified2ViewDTO>>(`${this._baseUrl}/${this._routePrefix}/ViewClassified`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        }, signal)
    }

    getWtruCodeGroup(id: string, callback?: (e: CoreApiResponse<IGoodsWtruCodeGroupDTO>) => void, failedCallback?: (e) => void) {
        this.get<IGoodsWtruCodeGroupDTO>(`${this._baseUrl}/${this._routePrefix}/${id}/WtruCodeGroup`, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    if (failedCallback) failedCallback(e)
                    else this._eventHandler.onGetResponse(e);
                } else {
                    callback?.(e);
                }
            }
        })
    }

    getByManyId(ids: string[], callback: (e: CoreApiResponse<IGoodsDTO[]>) => void, signal?: AbortSignal | null) {        
        this.post<IGoodsDTO[]>(`${this._baseUrl}/${this._routePrefix}/GetMany`,ids, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        }, signal)
    }

}

export default GoodsRequest